var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMoney3 = function SvgIconMoney3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060E41",
    d: "M28.333 5.833H11.666c-5 0-8.333 2.5-8.333 8.333v11.667c0 5.833 3.333 8.333 8.333 8.333h16.667c5 0 8.333-2.5 8.333-8.333V14.166c0-5.833-3.333-8.333-8.333-8.333m-15 23.75h-5a1.26 1.26 0 0 1-1.25-1.25c0-.683.567-1.25 1.25-1.25h5c.683 0 1.25.567 1.25 1.25a1.26 1.26 0 0 1-1.25 1.25M20 25c-2.767 0-5-2.234-5-5s2.233-5 5-5 5 2.233 5 5-2.234 5-5 5m11.666-12.084h-5a1.26 1.26 0 0 1-1.25-1.25c0-.683.567-1.25 1.25-1.25h5c.684 0 1.25.567 1.25 1.25 0 .684-.566 1.25-1.25 1.25"
  })));
};
export default SvgIconMoney3;